import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import { required, maxLength } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import axios from "axios";
import $ from "jquery";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "jobRequestCreate",

    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            isLoading: false,
            fullPage: true,
            jobRequestForm: {
                title: "",
                job_request_detail: ""
            },
            submitted: false,
        };
    },

    validations: {
        jobRequestForm: {
            title: {
                required,
                maxLength: maxLength(100)
            },
            job_request_detail: {
                required,
                maxLength: maxLength(1000)
            }
        }
    },

    computed: {
        ...mapGetters({ applicantId: "applicantId" })
    },

    methods: {
        submitJobRequest() {
            this.submitted = true;
            if (this.$v.jobRequestForm.$invalid) {
                return;
            }
            this.createJobRequest();
        },

        createJobRequest() {
            $("#block-btn").attr("disabled", true);
            this.isLoading = true;
            var request = {
                applicant_id: this.applicantId,
                job_request_title: this.jobRequestForm.title,
                job_request_details: this.jobRequestForm.job_request_detail
            };
            axios.post("applicant/job_request/create", request)
                .then(() => {
                    this.$notification.success("ပိုစ့် တင်ပြီးပါပြီ။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    this.isLoading = false;
                    this.$router.push({
                        name: "jobRequest"
                    });
                })
                .catch(error => {
                    this.isLoading = false;
                    $("#block-btn").attr("disabled", false);
                    var msg = "လုပ်ဆောင်ချက် မအောင်မြင်ပါ။";
                    if (error.response && error.response.data && error.response.data.message) {
                        msg = error.response.data.message;
                    }
                    this.$notification.error(msg, {
                        timer: 4,
                        position: "bottomCenter"
                    });
                    console.log("job request error", error);
                });
        }
    }
};